(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888],{

/***/ 8357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ emotion_cache_browser_esm; }
});

;// CONCATENATED MODULE: ./node_modules/@emotion/sheet/dist/emotion-sheet.browser.esm.js
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (false) { var isImportRule; }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {}
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (false) {}
  };

  return StyleSheet;
}();



;// CONCATENATED MODULE: ./node_modules/stylis/src/Utility.js
/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs

/**
 * @param {number}
 * @return {string}
 */
var Utility_from = String.fromCharCode

/**
 * @param {object}
 * @return {object}
 */
var Utility_assign = Object.assign

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return (((((((length << 2) ^ Utility_charat(value, 0)) << 2) ^ Utility_charat(value, 1)) << 2) ^ Utility_charat(value, 2)) << 2) ^ Utility_charat(value, 3)
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function Utility_charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function Utility_substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function Utility_strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function Utility_sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function Utility_append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function Utility_combine (array, callback) {
	return array.map(callback).join('')
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Tokenizer.js


var line = 1
var column = 1
var Tokenizer_length = 0
var position = 0
var character = 0
var characters = ''

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy (root, props) {
	return Utility_assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function Tokenizer_char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? Utility_charat(characters, --position) : 0

	if (column--, character === 10)
		column = 1, line--

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < Tokenizer_length ? Utility_charat(characters, position++) : 0

	if (column++, character === 10)
		column = 1, line++

	return character
}

/**
 * @return {number}
 */
function peek () {
	return Utility_charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return Utility_substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, Tokenizer_length = Utility_strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {string} value
 * @return {string[]}
 */
function Tokenizer_tokenize (value) {
	return dealloc(tokenizer(alloc(value)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next()
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {string[]} children
 * @return {string[]}
 */
function tokenizer (children) {
	while (next())
		switch (token(character)) {
			case 0: append(identifier(position - 1), children)
				break
			case 2: append(delimit(character), children)
				break
			default: append(from(character), children)
		}

	return children
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character)
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type)
				break
			// \
			case 92:
				next()
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + Utility_from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next()

	return slice(index, position)
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Enum.js
var MS = '-ms-'
var MOZ = '-moz-'
var WEBKIT = '-webkit-'

var COMMENT = 'comm'
var Enum_RULESET = 'rule'
var DECLARATION = 'decl'

var PAGE = '@page'
var MEDIA = '@media'
var IMPORT = '@import'
var CHARSET = '@charset'
var VIEWPORT = '@viewport'
var SUPPORTS = '@supports'
var DOCUMENT = '@document'
var NAMESPACE = '@namespace'
var KEYFRAMES = '@keyframes'
var FONT_FACE = '@font-face'
var COUNTER_STYLE = '@counter-style'
var FONT_FEATURE_VALUES = '@font-feature-values'

;// CONCATENATED MODULE: ./node_modules/stylis/src/Serializer.js



/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize (children, callback) {
	var output = ''
	var length = Utility_sizeof(children)

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || ''

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case IMPORT: case DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case KEYFRAMES: return element.return = element.value + '{' + serialize(element.children, callback) + '}'
		case Enum_RULESET: element.value = element.props.join(',')
	}

	return Utility_strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Prefixer.js



/**
 * @param {string} value
 * @param {number} length
 * @return {string}
 */
function prefix (value, length) {
	switch (hash(value, length)) {
		// color-adjust
		case 5103:
			return WEBKIT + 'print-' + value + value
		// animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
		case 5737: case 4201: case 3177: case 3433: case 1641: case 4457: case 2921:
		// text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
		case 5572: case 6356: case 5844: case 3191: case 6645: case 3005:
		// mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
		case 6391: case 5879: case 5623: case 6135: case 4599: case 4855:
		// background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
		case 4215: case 6389: case 5109: case 5365: case 5621: case 3829:
			return WEBKIT + value + value
		// appearance, user-select, transform, hyphens, text-size-adjust
		case 5349: case 4246: case 4810: case 6968: case 2756:
			return WEBKIT + value + MOZ + value + MS + value + value
		// flex, flex-direction
		case 6828: case 4268:
			return WEBKIT + value + MS + value + value
		// order
		case 6165:
			return WEBKIT + value + MS + 'flex-' + value + value
		// align-items
		case 5187:
			return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value
		// align-self
		case 5443:
			return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/, '') + value
		// align-content
		case 4675:
			return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/, '') + value
		// flex-shrink
		case 5548:
			return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value
		// flex-basis
		case 5292:
			return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value
		// flex-grow
		case 6060:
			return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value
		// transition
		case 4554:
			return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value
		// cursor
		case 6187:
			return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value
		// background, background-image
		case 5495: case 3959:
			return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1')
		// justify-content
		case 4968:
			return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value
		// (margin|padding)-inline-(start|end)
		case 4095: case 3583: case 4068: case 2532:
			return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value
		// (min|max)?(width|height|inline-size|block-size)
		case 8116: case 7059: case 5753: case 5535:
		case 5445: case 5701: case 4933: case 4677:
		case 5533: case 5789: case 5021: case 4765:
			// stretch, max-content, min-content, fill-available
			if (Utility_strlen(value) - 1 - length > 6)
				switch (Utility_charat(value, length + 1)) {
					// (m)ax-content, (m)in-content
					case 109:
						// -
						if (Utility_charat(value, length + 4) !== 45)
							break
					// (f)ill-available, (f)it-content
					case 102:
						return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (Utility_charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value
					// (s)tretch
					case 115:
						return ~indexof(value, 'stretch') ? prefix(replace(value, 'stretch', 'fill-available'), length) + value : value
				}
			break
		// position: sticky
		case 4949:
			// (s)ticky?
			if (Utility_charat(value, length + 1) !== 115)
				break
		// display: (flex|inline-flex)
		case 6444:
			switch (Utility_charat(value, Utility_strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
				// stic(k)y
				case 107:
					return replace(value, ':', ':' + WEBKIT) + value
				// (inline-)?fl(e)x
				case 101:
					return replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (Utility_charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value
			}
			break
		// writing-mode
		case 5936:
			switch (Utility_charat(value, length + 11)) {
				// vertical-l(r)
				case 114:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value
				// vertical-r(l)
				case 108:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value
				// horizontal(-)tb
				case 45:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value
			}

			return WEBKIT + value + MS + value + value
	}

	return value
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Middleware.js






/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = Utility_sizeof(collection)

	return function (element, index, children, callback) {
		var output = ''

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || ''

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element)
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case DECLARATION: element.return = prefix(element.value, element.length)
					break
				case KEYFRAMES:
					return serialize([copy(element, {value: replace(element.value, '@', '@' + WEBKIT)})], callback)
				case Enum_RULESET:
					if (element.length)
						return Utility_combine(element.props, function (value) {
							switch (match(value, /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									return serialize([copy(element, {props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]})], callback)
								// :placeholder
								case '::placeholder':
									return serialize([
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]})
									], callback)
							}

							return ''
						})
			}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 */
function namespace (element) {
	switch (element.type) {
		case RULESET:
			element.props = element.props.map(function (value) {
				return combine(tokenize(value), function (value, index, children) {
					switch (charat(value, 0)) {
						// \f
						case 12:
							return substr(value, 1, strlen(value))
						// \0 ( + > ~
						case 0: case 40: case 43: case 62: case 126:
							return value
						// :
						case 58:
							if (children[++index] === 'global')
								children[index] = '', children[++index] = '\f' + substr(children[index], index = 1, -1)
						// \s
						case 32:
							return index === 1 ? '' : value
						default:
							switch (index) {
								case 0: element = value
									return sizeof(children) > 1 ? '' : value
								case index = sizeof(children) - 1: case 2:
									return index === 2 ? value + element + element : value + element
								default:
									return value
							}
					}
				})
			})
	}
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Parser.js




/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0
	var offset = 0
	var length = pseudo
	var atrule = 0
	var property = 0
	var previous = 0
	var variable = 1
	var scanning = 1
	var ampersand = 1
	var character = 0
	var type = ''
	var props = rules
	var children = rulesets
	var reference = rule
	var characters = type

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && characters.charCodeAt(length - 1) == 58) {
					if (indexof(characters += replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character)
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous)
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7)
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						Utility_append(comment(commenter(next(), caret()), root, parent), declarations)
						break
					default:
						characters += '/'
				}
				break
			// {
			case 123 * variable:
				points[index++] = Utility_strlen(characters) * ampersand
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0
					// ;
					case 59 + offset:
						if (property > 0 && (Utility_strlen(characters) - length))
							Utility_append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations)
						break
					// @ ;
					case 59: characters += ';'
					// { rule/at-rule
					default:
						Utility_append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets)

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children)
							else
								switch (atrule) {
									// d m s
									case 100: case 109: case 115:
										parse(value, reference, reference, rule && Utility_append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children)
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children)
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo
				break
			// :
			case 58:
				length = 1 + Utility_strlen(characters), property = previous
			default:
				if (variable < 1)
					if (character == 123)
						--variable
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += Utility_from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1)
						break
					// ,
					case 44:
						points[index++] = (Utility_strlen(characters) - 1) * ampersand, ampersand = 1
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next())

						atrule = peek(), offset = length = Utility_strlen(type = characters += identifier(caret())), character++
						break
					// -
					case 45:
						if (previous === 45 && Utility_strlen(characters) == 2)
							variable = 0
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1
	var rule = offset === 0 ? rules : ['']
	var size = Utility_sizeof(rule)

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = Utility_substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x])))
				props[k++] = z

	return node(value, root, parent, offset === 0 ? Enum_RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, Utility_from(Tokenizer_char()), Utility_substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, DECLARATION, Utility_substr(value, 0, length), Utility_substr(value, length + 1, -1), length)
}

;// CONCATENATED MODULE: ./node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js





var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += Utility_from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule' || cache.compat) return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses) {
      var isNested = element.parent === children[0]; // in nested rules comments become children of the "auto-inserted" rule
      //
      // considering this input:
      // .a {
      //   .b /* comm */ {}
      //   color: hotpink;
      // }
      // we get output corresponding to this:
      // .a {
      //   & {
      //     /* comm */
      //     color: hotpink;
      //   }
      //   .b {}
      // }

      var commentContainer = isNested ? children[0].children : // global rule at the root level
      children;

      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node = commentContainer[i];

        if (node.line < element.line) {
          break;
        } // it is quite weird but comments are *usually* put at `column: element.column - 1`
        // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
        // this will also match inputs like this:
        // .a {
        //   /* comm */
        //   .b {}
        // }
        //
        // but that is fine
        //
        // it would be the easiest to change the placement of the comment to be the first child of the rule:
        // .a {
        //   .b { /* comm */ }
        // }
        // with such inputs we wouldn't have to search for the comment at all
        // TODO: consider changing this comment placement in the next major version


        if (node.column < element.column) {
          if (isIgnoringComment(node)) {
            return;
          }

          break;
        }
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

var defaultStylisPlugins = [prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (false) {}

  if ( key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (false) {}

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (false) {}

  {
    var currentSheet;
    var finalizingPlugins = [stringify,  false ? 0 : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (false) {}

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

/* harmony default export */ var emotion_cache_browser_esm = (createCache);


/***/ }),

/***/ 5042:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (memoize);


/***/ }),

/***/ 1683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ ThemeContext; },
  "a": function() { return /* binding */ ThemeProvider; },
  "w": function() { return /* binding */ withEmotionCache; }
});

// UNUSED EXPORTS: C, E, _, b, c, h, u

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js + 8 modules
var emotion_cache_browser_esm = __webpack_require__(8357);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
;// CONCATENATED MODULE: ./node_modules/@emotion/weak-memoize/dist/emotion-weak-memoize.esm.js
var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

/* harmony default export */ var emotion_weak_memoize_esm = (weakMemoize);

// EXTERNAL MODULE: ./node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js + 2 modules
var emotion_serialize_browser_esm = __webpack_require__(8137);
// EXTERNAL MODULE: ./node_modules/@emotion/use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.browser.esm.js
var emotion_use_insertion_effect_with_fallbacks_browser_esm = __webpack_require__(7278);
;// CONCATENATED MODULE: ./node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js









var emotion_element_6a883da9_browser_esm_hasOwnProperty = {}.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */(0,react.createContext)( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */(0,emotion_cache_browser_esm/* default */.Z)({
  key: 'css'
}) : null);

if (false) {}

var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
  return useContext(EmotionCacheContext);
};

var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
    // the cache will never be null in the browser
    var cache = (0,react.useContext)(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

var ThemeContext = /* #__PURE__ */(0,react.createContext)({});

if (false) {}

var useTheme = function useTheme() {
  return useContext(ThemeContext);
};

var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    if (false) {}

    return mergedTheme;
  }

  if (false) {}

  return (0,esm_extends/* default */.Z)({}, outerTheme, theme);
};

var createCacheWithTheme = /* #__PURE__ */emotion_weak_memoize_esm(function (outerTheme) {
  return emotion_weak_memoize_esm(function (theme) {
    return getTheme(outerTheme, theme);
  });
});
var ThemeProvider = function ThemeProvider(props) {
  var theme = (0,react.useContext)(ThemeContext);

  if (props.theme !== theme) {
    theme = createCacheWithTheme(theme)(props.theme);
  }

  return /*#__PURE__*/(0,react.createElement)(ThemeContext.Provider, {
    value: theme
  }, props.children);
};
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || 'Component';

  var render = function render(props, ref) {
    var theme = useContext(ThemeContext);
    return /*#__PURE__*/createElement(Component, _extends({
      theme: theme,
      ref: ref
    }, props));
  }; // $FlowFixMe


  var WithTheme = /*#__PURE__*/forwardRef(render);
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return hoistNonReactStatics(WithTheme, Component);
}

var getLastPart = function getLastPart(functionName) {
  // The match may be something like 'Object.createEmotionProps' or
  // 'Loader.prototype.render'
  var parts = functionName.split('.');
  return parts[parts.length - 1];
};

var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
  // V8
  var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
  if (match) return getLastPart(match[1]); // Safari / Firefox

  match = /^([A-Za-z0-9$.]+)@/.exec(line);
  if (match) return getLastPart(match[1]);
  return undefined;
};

var internalReactFunctionNames = /* #__PURE__ */new Set(['renderWithHooks', 'processChild', 'finishClassComponent', 'renderToString']); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
  if (!stackTrace) return undefined;
  var lines = stackTrace.split('\n');

  for (var i = 0; i < lines.length; i++) {
    var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"

    if (!functionName) continue; // If we reach one of these, we have gone too far and should quit

    if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
    // uppercase letter

    if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
  }

  return undefined;
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {}

  var newProps = {};

  for (var key in props) {
    if (emotion_element_6a883da9_browser_esm_hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
  // the label hasn't already been computed

  if (false) { var label; }

  return newProps;
};

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {
    return insertStyles(cache, serialized, isStringTag);
  });

  return null;
};

var Emotion = /* #__PURE__ */(/* unused pure expression or super */ null && (withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles, undefined, useContext(ThemeContext));

  if (false) { var labelFromStack; }

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (emotion_element_6a883da9_browser_esm_hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ( true || 0)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Insertion, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/createElement(WrappedComponent, newProps));
})));

if (false) {}




/***/ }),

/***/ 917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F4": function() { return /* binding */ keyframes; },
/* harmony export */   "iv": function() { return /* binding */ css; },
/* harmony export */   "xB": function() { return /* binding */ Global; }
/* harmony export */ });
/* unused harmony exports ClassNames, createElement, jsx */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8357);
/* harmony import */ var _emotion_element_6a883da9_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1683);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8679);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _emotion_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(444);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8137);
/* harmony import */ var _emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7278);












var pkg = {
	name: "@emotion/react",
	version: "11.10.4",
	main: "dist/emotion-react.cjs.js",
	module: "dist/emotion-react.esm.js",
	browser: {
		"./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
	},
	exports: {
		".": {
			module: {
				worker: "./dist/emotion-react.worker.esm.js",
				browser: "./dist/emotion-react.browser.esm.js",
				"default": "./dist/emotion-react.esm.js"
			},
			"default": "./dist/emotion-react.cjs.js"
		},
		"./jsx-runtime": {
			module: {
				worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
				browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
				"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
			},
			"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
		},
		"./_isolated-hnrs": {
			module: {
				worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
				browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
				"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
			},
			"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
		},
		"./jsx-dev-runtime": {
			module: {
				worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
				browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
				"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
			},
			"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
		},
		"./package.json": "./package.json",
		"./types/css-prop": "./types/css-prop.d.ts",
		"./macro": "./macro.js"
	},
	types: "types/index.d.ts",
	files: [
		"src",
		"dist",
		"jsx-runtime",
		"jsx-dev-runtime",
		"_isolated-hnrs",
		"types/*.d.ts",
		"macro.js",
		"macro.d.ts",
		"macro.js.flow"
	],
	sideEffects: false,
	author: "Emotion Contributors",
	license: "MIT",
	scripts: {
		"test:typescript": "dtslint types"
	},
	dependencies: {
		"@babel/runtime": "^7.18.3",
		"@emotion/babel-plugin": "^11.10.0",
		"@emotion/cache": "^11.10.0",
		"@emotion/serialize": "^1.1.0",
		"@emotion/use-insertion-effect-with-fallbacks": "^1.0.0",
		"@emotion/utils": "^1.2.0",
		"@emotion/weak-memoize": "^0.3.0",
		"hoist-non-react-statics": "^3.3.1"
	},
	peerDependencies: {
		"@babel/core": "^7.0.0",
		react: ">=16.8.0"
	},
	peerDependenciesMeta: {
		"@babel/core": {
			optional: true
		},
		"@types/react": {
			optional: true
		}
	},
	devDependencies: {
		"@babel/core": "^7.18.5",
		"@definitelytyped/dtslint": "0.0.112",
		"@emotion/css": "11.10.0",
		"@emotion/css-prettifier": "1.1.0",
		"@emotion/server": "11.10.0",
		"@emotion/styled": "11.10.4",
		"html-tag-names": "^1.1.2",
		react: "16.14.0",
		"svg-tag-names": "^1.1.1",
		typescript: "^4.5.5"
	},
	repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
	publishConfig: {
		access: "public"
	},
	"umd:main": "dist/emotion-react.umd.min.js",
	preconstruct: {
		entrypoints: [
			"./index.js",
			"./jsx-runtime.js",
			"./jsx-dev-runtime.js",
			"./_isolated-hnrs.js"
		],
		umdName: "emotionReact",
		exports: {
			envConditions: [
				"browser",
				"worker"
			],
			extra: {
				"./types/css-prop": "./types/css-prop.d.ts",
				"./macro": "./macro.js"
			}
		}
	}
};

var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !hasOwnProperty.call(props, 'css')) {
    // $FlowFixMe
    return createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return createElement.apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */(0,_emotion_element_6a883da9_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.w)(function (props, cache) {
  if (false) {}

  var styles = props.styles;
  var serialized = (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_3__/* .serializeStyles */ .O)([styles], undefined, (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_emotion_element_6a883da9_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.T));
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  (0,_emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_4__/* .useInsertionEffectWithLayoutFallback */ .j)(function () {
    var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675

    var sheet = new cache.sheet.constructor({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false; // $FlowFixMe

    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  (0,_emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_4__/* .useInsertionEffectWithLayoutFallback */ .j)(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_6__/* .insertStyles */ .My)(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
});

if (false) {}

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_3__/* .serializeStyles */ .O)(args);
}

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            if (false) {}

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serializedArr = _ref.serializedArr;
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {

    for (var i = 0; i < serializedArr.length; i++) {
      var res = insertStyles(cache, serializedArr[i], false);
    }
  });

  return null;
};

var ClassNames = /* #__PURE__ */(/* unused pure expression or super */ null && (withEmotionCache(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];

  var css = function css() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`

    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return merge(cache.registered, css, classnames(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: useContext(ThemeContext)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Insertion, {
    cache: cache,
    serializedArr: serializedArr
  }), ele);
})));

if (false) {}

if (false) { var globalKey, globalContext, isJest, isBrowser; }




/***/ }),

/***/ 8137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ serializeStyles; }
});

;// CONCATENATED MODULE: ./node_modules/@emotion/hash/dist/emotion-hash.esm.js
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

/* harmony default export */ var emotion_hash_esm = (murmur2);

;// CONCATENATED MODULE: ./node_modules/@emotion/unitless/dist/emotion-unitless.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var emotion_unitless_esm = (unitlessKeys);

// EXTERNAL MODULE: ./node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
var emotion_memoize_esm = __webpack_require__(5042);
;// CONCATENATED MODULE: ./node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */(0,emotion_memoize_esm/* default */.Z)(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (emotion_unitless_esm[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

var noComponentSelectorMessage = (/* unused pure expression or super */ null && ('Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.'));

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = emotion_hash_esm(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};




/***/ }),

/***/ 7278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useInsertionEffectAlwaysWithSyncFallback; },
/* harmony export */   "j": function() { return /* binding */ useInsertionEffectWithLayoutFallback; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);



var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] ? /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback =  useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;




/***/ }),

/***/ 444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "My": function() { return /* binding */ insertStyles; },
/* harmony export */   "fp": function() { return /* binding */ getRegisteredStyles; },
/* harmony export */   "hC": function() { return /* binding */ registerStyles; }
/* harmony export */ });
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};




/***/ }),

/***/ 3067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "eB": function() { return /* binding */ baukastenTheme; },
/* harmony export */   "f6": function() { return /* binding */ ThemeProvider; }
/* harmony export */ });
/* unused harmony export BaukastenThemeProvider */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(917);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1683);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(655);




// Raw tokens
/* Don't use Raw Tokens directly on custom components, use Alias Tokens instead */
var raw = {
    // Primary
    governorBay: '#3331B6',
    cornflowerBlue: '#6663FD',
    melrose: '#B2B0FD',
    periwinkle: '#D1D0FE',
    titanWhite: '#F2F1FF',
    // Neutral
    black: '#000000',
    haiti: '#090E24',
    blueZodiac: '#101B42',
    rhino: '#333F69',
    waikawaGray: '#626E99',
    rockBlue: '#9DA6C7',
    pigeonPost: '#BAC2DB',
    mischka: '#D0D4E0',
    snuff: '#DADEED',
    whisper: '#ECEEF5',
    catskillWhite: '#F0F2F7',
    athensGray: '#F8F9FB',
    white: '#FFFFFF',
    // Green
    eveningSea: '#04543F',
    shamrock: '#32C48D',
    algaeGreen: '#98E1C5',
    jaggedIce: '#C3E8D8',
    blackSqueeze: '#F2FAF7',
    // Red
    oldBrick: '#9A1C1C',
    cinnabar: '#E53E3E',
    wewak: '#F19E9E',
    cinderella: '#FDD9D9',
    linen: '#FDF2F2',
    // Yellow
    korma: '#8E4B10',
    gamboge: '#E3A008',
    buff: '#F0CF83',
    givry: '#F7E3B5',
    butteryWhite: '#FFFBEB',
    // Blue
    denim: '#1A56DB',
    malibu: '#76A9FA',
    hawkesBlue: '#D6E5FE',
    zumthor: '#EBF5FF',
    // Rose
    frenchRose: '#F5487F',
    lavenderBlush: '#FFEFF4',
    // RoyalBlue
    royalBlue: '#6246EA',
    // Cerulean Blue
    ceruleanBlue: '#2B6CB0',
    solitude: '#EBF8FF',
    // Purple
    fuchsiaBlue: '#6B46C1',
    magnolia: '#FAF5FF',
    // Pink
    mediumRedViolet: '#B83280',
    amour: '#FFF5F7',
    // Sea Green
    greenPea: '#276749',
    feta: '#EAFDEF',
    // Orange
    piper: '#C05621',
    bridalHeath: '#FFFAF0',
    // Persian Red
    persianRed: '#C53030',
    chablis: '#FFF5F5',
    // Brown
    paarl: '#A05D31',
    vistaWhite: '#FAF3F3',
    // Olive
    woodland: '#486C2B',
    frost: '#F2F9EC',
    // Teal
    paradiso: '#2C7A7B',
    clearDay: '#E6FFFA',
    // Tan
    hawaiianTan: '#975A16',
    apricotWhite: '#FFFFEB',
    // Indigo
    indigo: '#4C51BF',
    zircon: '#EBF4FF',
};
// Alias
var brand = {
    700: raw.governorBay,
    500: raw.cornflowerBlue,
    200: raw.melrose,
    100: raw.periwinkle,
    50: raw.titanWhite,
};
var neutral = {
    900: raw.haiti,
    700: raw.blueZodiac,
    400: raw.rhino,
    300: raw.waikawaGray,
    250: raw.rockBlue,
    200: raw.pigeonPost,
    150: raw.mischka,
    100: raw.snuff,
    50: raw.whisper,
    25: raw.catskillWhite,
    10: raw.athensGray,
};
var green = {
    700: raw.eveningSea,
    500: raw.shamrock,
    200: raw.algaeGreen,
    100: raw.jaggedIce,
    50: raw.blackSqueeze,
};
var red = {
    700: raw.oldBrick,
    500: raw.cinnabar,
    200: raw.wewak,
    100: raw.cinderella,
    50: raw.linen,
};
var yellow = {
    700: raw.korma,
    500: raw.gamboge,
    200: raw.buff,
    100: raw.givry,
    50: raw.butteryWhite,
};
var blue = {
    700: raw.denim,
    500: raw.malibu,
    100: raw.hawkesBlue,
    50: raw.zumthor,
};
var rose = {
    700: raw.frenchRose,
    100: raw.lavenderBlush,
};
var royalBlue = {
    500: raw.royalBlue,
};
var ceruleanBlue = {
    700: raw.ceruleanBlue,
    100: raw.solitude,
};
var purple = {
    700: raw.fuchsiaBlue,
    100: raw.magnolia,
};
var pink = {
    700: raw.mediumRedViolet,
    100: raw.amour,
};
var seaGreen = {
    700: raw.greenPea,
    100: raw.feta,
};
var orange = {
    700: raw.piper,
    100: raw.bridalHeath,
};
var persianRed = {
    700: raw.persianRed,
    100: raw.chablis,
};
var brown = {
    700: raw.paarl,
    100: raw.vistaWhite,
};
var olive = {
    700: raw.woodland,
    100: raw.frost,
};
var teal = {
    700: raw.paradiso,
    100: raw.clearDay,
};
var tan = {
    700: raw.hawaiianTan,
    100: raw.apricotWhite,
};
var indigo = {
    700: raw.indigo,
    100: raw.zircon,
};
var colors = {
    // Alias
    brand: brand,
    neutral: neutral,
    green: green,
    red: red,
    yellow: yellow,
    blue: blue,
    rose: rose,
    royalBlue: royalBlue,
    ceruleanBlue: ceruleanBlue,
    purple: purple,
    pink: pink,
    seaGreen: seaGreen,
    orange: orange,
    persianRed: persianRed,
    brown: brown,
    olive: olive,
    teal: teal,
    tan: tan,
    indigo: indigo,
    // Component Specific Colors
    feedback: {
        success: {
            background: raw.blackSqueeze,
            foreground: raw.eveningSea,
            border: raw.shamrock,
            icon: raw.shamrock,
        },
        error: {
            background: raw.linen,
            foreground: raw.oldBrick,
            border: raw.cinnabar,
            icon: raw.cinnabar,
        },
        warning: {
            background: raw.butteryWhite,
            foreground: raw.korma,
            border: raw.gamboge,
            icon: raw.gamboge,
        },
        info: {
            background: raw.zumthor,
            foreground: raw.denim,
            border: raw.malibu,
            icon: raw.malibu,
        },
        // Extended Palette for Toast
        primary: {
            background: raw.titanWhite,
            foreground: raw.cornflowerBlue,
            border: raw.cornflowerBlue,
            icon: raw.melrose,
        },
        dark: {
            background: raw.haiti,
            foreground: raw.white,
            border: raw.haiti,
            icon: raw.white,
        },
    },
    button: {
        solid: {
            foreground: raw.white,
            primary: {
                default: raw.cornflowerBlue,
                hover: raw.governorBay,
                focus_outline: raw.periwinkle,
                disabled: raw.melrose,
            },
            success: {
                default: raw.shamrock,
                hover: raw.eveningSea,
                focus_outline: raw.jaggedIce,
                disabled: raw.algaeGreen,
            },
            danger: {
                default: raw.cinnabar,
                hover: raw.oldBrick,
                focus_outline: raw.cinderella,
                disabled: raw.wewak,
            },
            warning: {
                default: raw.gamboge,
                hover: raw.korma,
                focus_outline: raw.givry,
                disabled: raw.buff,
            },
        },
        outline: {
            primary: {
                default: {
                    background: raw.white,
                    foreground: raw.cornflowerBlue,
                    border: raw.snuff,
                    icon: raw.cornflowerBlue,
                },
                hover: {
                    background: raw.catskillWhite,
                    icon: raw.cornflowerBlue,
                },
                focus_outline: raw.periwinkle,
                disabled: {
                    background: raw.athensGray,
                    foreground: raw.melrose,
                    border: raw.whisper,
                },
            },
            secondary: {
                default: {
                    background: raw.athensGray,
                    foreground: raw.waikawaGray,
                    border: raw.snuff,
                    icon: raw.rockBlue,
                },
                hover: {
                    background: raw.catskillWhite,
                    icon: raw.waikawaGray,
                },
                focus_outline: raw.mischka,
                disabled: {
                    background: raw.athensGray,
                    foreground: raw.pigeonPost,
                    border: raw.whisper,
                },
            },
        },
        ghost: {
            primary: {
                foreground: raw.cornflowerBlue,
                icon: raw.cornflowerBlue,
                hover: {
                    background: raw.catskillWhite,
                    icon: raw.cornflowerBlue,
                },
                focus_outline: raw.periwinkle,
                disabled: raw.melrose,
            },
            secondary: {
                foreground: raw.waikawaGray,
                icon: raw.rockBlue,
                hover: {
                    background: raw.catskillWhite,
                    icon: raw.waikawaGray,
                },
                focus_outline: raw.mischka,
                disabled: raw.pigeonPost,
            },
            secondaryDark: {
                foreground: raw.waikawaGray,
                icon: raw.waikawaGray,
                hover: {
                    background: raw.catskillWhite,
                    icon: raw.waikawaGray,
                },
                focus_outline: raw.mischka,
                disabled: raw.pigeonPost,
            },
            success: {
                foreground: raw.eveningSea,
                icon: raw.shamrock,
                hover: {
                    background: raw.blackSqueeze,
                    icon: raw.eveningSea,
                },
                focus_outline: raw.jaggedIce,
                disabled: raw.algaeGreen,
            },
            danger: {
                foreground: raw.oldBrick,
                icon: raw.cinnabar,
                hover: {
                    background: raw.linen,
                    icon: raw.oldBrick,
                },
                focus_outline: raw.cinderella,
                disabled: raw.wewak,
            },
            warning: {
                foreground: raw.korma,
                icon: raw.gamboge,
                hover: {
                    background: raw.butteryWhite,
                    icon: raw.korma,
                },
                focus_outline: raw.givry,
                disabled: raw.buff,
            },
        },
        dashed: {
            secondary: {
                default: {
                    background: raw.athensGray,
                    foreground: raw.waikawaGray,
                    border: raw.snuff,
                    icon: raw.rockBlue,
                },
                hover: {
                    background: raw.catskillWhite,
                    icon: raw.waikawaGray,
                },
                focus_outline: raw.mischka,
                disabled: {
                    background: raw.athensGray,
                    foreground: raw.pigeonPost,
                    border: raw.whisper,
                },
            },
            primary: {
                default: {
                    background: raw.athensGray,
                    foreground: raw.cornflowerBlue,
                    border: raw.snuff,
                    icon: raw.cornflowerBlue,
                },
                hover: {
                    background: raw.catskillWhite,
                    icon: raw.cornflowerBlue,
                },
                focus_outline: raw.periwinkle,
                disabled: {
                    background: raw.athensGray,
                    foreground: raw.melrose,
                    border: raw.whisper,
                },
            },
        },
        link: {
            primary: {
                default: raw.cornflowerBlue,
                hover: raw.governorBay,
                disabled: raw.melrose,
            },
            secondary: {
                default: raw.waikawaGray,
                hover: raw.haiti,
                disabled: raw.pigeonPost,
            },
        },
    },
    avatar: {
        square: {
            background: raw.haiti,
            foreground: raw.white,
        },
        round: {
            background: raw.catskillWhite,
            foreground: raw.waikawaGray,
            inactive: raw.pigeonPost,
        },
        badge: {
            border: raw.white,
            background: raw.haiti,
        },
        group: {
            border: raw.white,
        },
    },
    switch: {
        box: {
            foreground: raw.white,
            unchecked: {
                default: raw.rockBlue,
                hover: raw.waikawaGray,
                disabled: raw.snuff,
                focus_outline: raw.mischka,
            },
            checked: {
                default: raw.cornflowerBlue,
                hover: raw.governorBay,
                disabled: raw.melrose,
                focus_outline: raw.periwinkle,
            },
        },
    },
    pill: {
        background: raw.catskillWhite,
        foreground: raw.waikawaGray,
    },
    tooltip: {
        background: raw.blueZodiac,
        foreground: raw.white,
    },
    breadcrumb: {
        link: {
            default: raw.waikawaGray,
            hover: raw.haiti,
            disabled: raw.pigeonPost,
            current: raw.haiti,
        },
        separator: raw.rockBlue,
        focus_outline: raw.mischka,
    },
    dialog: {
        overlay: 'RGBA(0, 0, 0, 0.5)',
        content: {
            background: raw.white,
            foreground: raw.haiti,
            shadow: 'RGBA(0, 0, 0, 0.08)',
        },
        header_border: raw.catskillWhite,
        footer: raw.athensGray,
    },
    // Tab
    tab: {
        pill: {
            inactive: {
                default: {
                    background: 'transparent',
                    foreground: raw.waikawaGray,
                },
                hover: raw.catskillWhite,
                focus_outline: raw.mischka,
                disabled: {
                    background: raw.athensGray,
                    foreground: raw.pigeonPost,
                },
            },
            active: {
                default: {
                    background: raw.titanWhite,
                    foreground: raw.cornflowerBlue,
                },
                focus_outline: raw.periwinkle,
                hover: raw.titanWhite,
            },
        },
        underline: {
            inactive: {
                default: {
                    background: 'transparent',
                    foreground: raw.waikawaGray,
                },
                hover: raw.catskillWhite,
                focus_outline: raw.mischka,
                disabled: {
                    background: raw.athensGray,
                    foreground: raw.pigeonPost,
                },
            },
            active: {
                default: {
                    background: raw.titanWhite,
                    foreground: raw.cornflowerBlue,
                },
                hover: raw.titanWhite,
                focus_outline: raw.periwinkle,
            },
            panel: {
                border: raw.catskillWhite,
            },
        },
    },
    dropdown: {
        list: {
            background: raw.white,
            border: raw.snuff,
            shadow: 'RGBA(0, 0, 0, 0.1)',
        },
        item: {
            background: 'transparent',
            foreground: raw.haiti,
            icon: raw.waikawaGray,
            hover: {
                background: raw.catskillWhite,
                icon: raw.haiti,
            },
            focus_outline: raw.mischka,
            disabled: raw.pigeonPost,
            danger: {
                foreground: raw.oldBrick,
                icon: raw.cinnabar,
                hover: {
                    background: raw.linen,
                    icon: raw.oldBrick,
                },
                focus_outline: raw.cinderella,
                disabled: raw.wewak,
            },
            warning: {
                foreground: raw.korma,
                icon: raw.gamboge,
                hover: {
                    background: raw.butteryWhite,
                    icon: raw.korma,
                },
                focus_outline: raw.givry,
                disabled: raw.buff,
            },
        },
    },
    // Input and Textarea
    input: {
        placeholder: raw.rockBlue,
        value: raw.haiti,
        icon: raw.rockBlue,
        background: raw.white,
        initial: {
            border: raw.mischka,
            readonly: {
                background: raw.athensGray,
                value: raw.waikawaGray,
            },
        },
        focus: {
            border: raw.cornflowerBlue,
            readonly: {
                background: raw.athensGray,
                border: raw.pigeonPost,
            },
        },
        disabled: {
            background: raw.catskillWhite,
            value: raw.rockBlue,
        },
        invalid: {
            border: raw.cinnabar,
        },
        valid: {
            border: raw.shamrock,
        },
        // Label for all form controls
        label: {
            default: raw.haiti,
            disabled: raw.rockBlue,
        },
        hint: {
            default: raw.waikawaGray,
            disabled: raw.rockBlue,
        },
    },
    // Radio & Checkbox
    checkbox: {
        box: {
            unchecked: {
                default: {
                    background: raw.white,
                    border: raw.rockBlue,
                },
                hover: raw.waikawaGray,
                disabled: {
                    background: raw.athensGray,
                    border: raw.snuff,
                },
                focus_outline: raw.mischka,
            },
            checked: {
                default: raw.cornflowerBlue,
                icon: raw.white,
                hover: raw.governorBay,
                disabled: raw.melrose,
                focus_outline: raw.periwinkle,
            },
        },
    },
    /* Color variables that will be replaced by Component or Alias tokens
      Please use the alias tokens in your components, if there are not component specific tokens created.
    */
    primary: raw.cornflowerBlue,
    white: '#FFFFFF',
    text: raw.haiti,
    textLight: raw.waikawaGray,
    textCaption: raw.rockBlue,
    textDark: raw.haiti,
    heading: raw.haiti,
    altText: 'rgba(255, 255, 255, 0.85)',
    /* These colors are only used in Baukasten and it will be replaced with component specific tokens,
    don't use on non Baukasten components, use aliases instead  */
    layoutBorder: raw.catskillWhite,
    backgroundBorder: raw.snuff,
    default: raw.waikawaGray,
    link: raw.cornflowerBlue,
    disabled: '#8f8f8f4f',
    label: raw.waikawaGray,
    labelHover: raw.rhino,
    labelOutlineHover: raw.snuff,
    // Form
    labelText: raw.haiti,
    hintText: raw.waikawaGray,
    caption: raw.rockBlue,
    captionHover: raw.waikawaGray,
    captionOutlineHover: raw.catskillWhite,
    inputBg: raw.white,
    inputDisabled: raw.waikawaGray,
    inputPlaceholder: raw.rockBlue,
    inputDisabledBg: raw.catskillWhite,
    inputBorder: raw.mischka,
    inputErrorBorder: raw.cinnabar,
    inputErrorText: raw.oldBrick,
    inputFocus: raw.cornflowerBlue,
    inputReadonly: 'rgb(123, 147, 164)',
    checkBoxBorder: raw.blueZodiac,
    checkBoxDisabledBorder: '#808080',
    checkBoxDisabledBg: '#D3D3D3',
    checkBoxHighlight: 'rgba(40,45,76,0.2)',
    primaryRadioHighlight: 'rgba(40,45,76,0.2)',
    dangerRadioHighlight: 'rgba(229,57,53,0.2)',
    warningRadioHighlight: 'rgba(255,152,0,0.2)',
    selectBg: raw.white,
    selectBgHover: raw.catskillWhite,
    selectListText: raw.haiti,
    multiSelectItemBg: '#e2e7ea',
    errorIconBackground: raw.cinnabar,
    successIconBackground: raw.shamrock,
    // Card
    cardBg: raw.white,
    tintedCardHeaderBg: '#f6faff',
    cardBorder: raw.catskillWhite,
    // Progress Bar
    progressBarBg: '#eff2fb',
    // Divider
    dividerColor: '#d9e3ed',
    // Menu
    menuBg: 'transparent',
    menuHeaderText: raw.waikawaGray,
    menuItemInactiveText: raw.haiti,
    menuItemInactiveHoverBg: raw.catskillWhite,
    menuItemInactiveFocus: 'rgba(98, 110, 153, 0.3)',
    menuItemActiveText: raw.cornflowerBlue,
    menuItemActiveBg: raw.titanWhite,
    menuItemActiveFocus: 'rgba(102,99,253, 0.3)',
};

var fonts = {
    body: 'Inter, -apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji;',
    heading: 'Inter, -apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji;',
    monospace: 'Source Code Pro, SFMono-Regular,Consolas,Liberation Mono,Menlo,monospace',
};
var fontSizes = {
    pill: '12px',
    tiny: '12px',
    sectionTitle: '12px',
    interface: '13px',
    copy: '15px',
    icon: '1.5em',
    h6: '14px',
    h5: '16px',
    h4: '18px',
    h3: '20px',
    h2: '24px',
    h1: '28px',
    inviteMembersInfo: '18px',
    stepTitle: '17px',
};
var fontWeights = {
    '100': 100,
    '200': 200,
    '300': 300,
    '400': 400,
    '500': 500,
    '600': 600,
    '700': 700,
    normal: 400,
    body: 400,
    heading: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
    activeMenuItem: 700,
    h1: 700,
    h2: 600,
    h3: 500,
    h4: 400,
    h5: 300,
    h6: 200,
};
var lineHeights = {
    none: '1em',
    small: '16px',
    sm: '18px',
    medium: '20px',
    regular: '24px',
    copy: '23px',
    double: '48px',
    heading: '24px',
    inviteMembersInfo: '28px',
    info: '20px',
    h1: '48px',
    h2: '40px',
    h3: '32px',
    h4: '24px',
    h5: '20px',
    h6: '20px',
    copySmall: '18px',
    error: '22px',
    dialogHeader: '22px',
};
var letterSpacings = {
    sectionTitle: '1.2px',
    cardStatusInfo: '1.2px',
};

var space = {
    '4': '4px',
    '6': '6px',
    '8': '8px',
    '10': '10px',
    '12': '12px',
    '24': '24px',
    '16': '16px',
    none: 0,
    xxs: 2,
    xs: 4,
    s: 8,
    sm: 12,
    m: 16,
    ml: 20,
    l: 24,
    xl: 32,
    layoutXS: 16,
    layoutS: 24,
    layoutSM: 28,
    layoutM: 32,
    layoutML: 40,
    layoutL: 48,
    layoutXL: 64,
    layoutXXL: 96,
};
var negativeSpace = Object.keys(space).reduce(function (neg, key) {
    if (key === 'none')
        return neg;
    var upperKey = key.charAt(0).toUpperCase() + key.slice(1);
    neg["neg".concat(upperKey)] = -space[key];
    return neg;
}, {});
var space$1 = (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)({}, space), negativeSpace);

/* Please keep all keys "string" or TS autocomplete wont work. */
var avatarSizes = {
    '16': '16px',
    '24': '24px',
    '32': '32px',
    '36': '36px',
    '40': '40px',
    '80': '80px',
    '148': '148px',
    '180': '180px',
};
var sizes = {
    auto: 'auto',
    // Baukasten component specific sizes
    avatar: avatarSizes,
    spinner: {
        xs: '0.75rem',
        s: '1rem',
        m: '1.5rem',
        l: '2rem',
        xl: '3rem',
    },
    button: {
        small: '24px',
        medium: '32px',
        large: '40px',
    },
    dialog: {
        medium: '588px',
        large: '792px',
        fullWidth: '100%',
    },
    // For components that use the iconSize or the  size prop
    icon: {
        '12': '12px',
        '16': '16px',
        '20': '20px',
        '24': '24px',
        '32': '32px',
        '48': '48px',
    },
    progress: {
        '5': '5px',
        '8': '8px',
        '16': '16px',
    },
    /* For components that use the size prop or width height,
      minWidth, maxWidth, minHeight, maxHeight */
    '4': '4px',
    '8': '8px',
    '12': '12px',
    '16': '16px',
    '20': '20px',
    '24': '24px',
    '28': '28px',
    '32': '32px',
    '36': '36px',
    '40': '40px',
    '44': '44px',
    '48': '48px',
    '52': '52px',
    '56': '56px',
    '60': '60px',
    '64': '64px',
    '72': '72px',
    '80': '80px',
    '96': '96px',
    '140': '140px',
    '180': '180px',
    '200': '200px',
    '208': '208px',
    '240': '240px',
    '248': '248px',
    '252': '252px',
    '256': '256px',
    '272': '272px',
    '280': '280px',
    '288': '288px',
    '300': '300px',
    '400': '400px',
    '320': '320px',
    '340': '340px',
    '360': '360px',
    '440': '440px',
    '456': '456px',
    '468': '468px',
    '500': '500px',
    '520': '520px',
    '564': '564px',
    '588': '588px',
    '600': '600px',
    '720': '720px',
    '792': '792px',
    '900': '900px',
    '960': '960px',
    '996': '996px',
    '1440': '1440px',
    contentFormDefaultWidth: '830px',
    contentFormWideWidth: '1220px',
    contentFormMaxWidth: '672px',
    contentFormCompactWidth: '692px',
};

var shadows = {
    light: '0 2px 4px rgba(0,0,0,0.05)',
    inputFocus: 'none',
    inputErrorFocus: 'none',
    inputAutofill: '0 0 0px 50px #fff inset',
    rightSideBar: '-1px 0 4px rgba(0,0,0,0.05)',
    input: '0 2px 4px rgba(0,0,0,0.05)',
    topBar: 'none',
    tableBorder: "0 0 0 1px ".concat(colors.backgroundBorder),
    menuItemInactiveFocus: "0 0 0 2px ".concat(colors.menuItemInactiveFocus),
    menuItemActiveFocus: "0 0 0 2px ".concat(colors.menuItemActiveFocus),
    // Baukasten Component specific shadows, don't use them in custom components
    dropdownMenuList: "0px 8px 14px 2px ".concat(colors.dropdown.list.shadow),
    toast: '0 8px 14px 2px rgba(0, 0, 0, 0.1)',
    card: '0px 2px 6px rgba(0,0,0,0.08)',
    cardHover: '0px 2px 6px rgba(0,0,0,0.1)',
    tooltip: '0 2px 4px rgba(0, 0, 0, 0.2)',
};

var radii = {
    small: '4px',
    medium: '8px',
    large: '16px',
    round: '9999px',
    card: '4px',
    input: '2px',
    tooltip: '3px',
    '2': '2px',
    '4': '4px',
    '8': '8px',
    '16': '16px',
};

// @ts-expect-error
var breakpoints = [
    '576px',
    '768px',
    '992px',
    '1200px',
];
breakpoints.sm = breakpoints[0];
breakpoints.md = breakpoints[1];
breakpoints.lg = breakpoints[2];
breakpoints.xl = breakpoints[3];

var text = {
    heading: {
        fontFamily: 'heading',
        lineHeight: 'heading',
        fontWeight: 'heading',
    },
};

var zIndexes = {
    modal: 2000,
    tooltip: 2010,
    tooltipArrow: '-1',
};

var borders = {
    layout: '1px solid',
    input: '1px solid',
    card: '1px solid',
    toast: '1px solid',
    disabledLayout: '1px dotted',
    tableHeader: '2px solid',
    activeMenu: '4px solid',
};
var borderWidths = {
    activeMenu: '4px',
};

var gap = {
    none: 0,
    '4': 4,
    '8': 8,
    '12': 12,
    '16': 16,
    '20': 20,
    '24': 24,
    '28': 28,
    '32': 32,
    '36': 36,
    '40': 40,
    '48': 48,
    '64': 64,
    '96': 96,
};

// tokens
var baukastenTheme = {
    borders: borders,
    borderWidths: borderWidths,
    colors: colors,
    fonts: fonts,
    fontSizes: fontSizes,
    fontWeights: fontWeights,
    lineHeights: lineHeights,
    letterSpacings: letterSpacings,
    space: space$1,
    sizes: sizes,
    shadows: shadows,
    radii: radii,
    text: text,
    breakpoints: breakpoints,
    zIndexes: zIndexes,
    gap: gap,
};

var makeGlobalStyles = (function (theme) {
    var fonts = theme.fonts, lineHeights = theme.lineHeights, fontSizes = theme.fontSizes, colors = theme.colors, fontWeights = theme.fontWeights;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(templateObject_1 || (templateObject_1 = (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__makeTemplateObject)(["\n    html {\n      font: ", " / ", " ", ";\n      box-sizing: border-box;\n      -ms-text-size-adjust: 100%;\n      -webkit-text-size-adjust: 100%;\n      width: 100%;\n    }\n    body {\n      margin: 0;\n      color: ", ";\n      font-weight: ", ";\n      word-wrap: break-word;\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale;\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      margin: 0;\n      padding: 0;\n      color: ", ";\n    }\n    h1 {\n      line-height: ", ";\n      font-size: ", ";\n      font-weight: ", ";\n    }\n    h2 {\n      line-height: ", ";\n      font-size: ", ";\n      font-weight: ", ";\n    }\n    h3 {\n      line-height: ", ";\n      font-size: ", ";\n      font-weight: ", ";\n    }\n    h4 {\n      line-height: ", ";\n      font-size: ", ";\n      font-weight: ", ";\n    }\n    h5 {\n      line-height: ", ";\n      font-size: ", ";\n      font-weight: ", ";\n    }\n    h6 {\n      line-height: ", ";\n      font-size: ", ";\n      font-weight: ", ";\n    }\n\n    a {\n      color: inherit;\n      text-decoration: none;\n      background-color: transparent;\n      -webkit-text-decoration-skip: objects;\n    }\n    a:active,\n    a:hover {\n      outline-width: 0;\n    }\n\n    * {\n      box-sizing: inherit;\n    }\n    *:before {\n      box-sizing: inherit;\n    }\n    *:after {\n      box-sizing: inherit;\n    }\n\n    article,\n    aside,\n    details,\n    figcaption,\n    figure,\n    footer,\n    header,\n    main,\n    menu,\n    nav,\n    section,\n    summary {\n      display: block;\n    }\n    audio,\n    canvas,\n    progress,\n    video {\n      display: inline-block;\n    }\n    audio:not([controls]) {\n      display: none;\n      height: 0;\n    }\n    progress {\n      vertical-align: baseline;\n    }\n    [hidden],\n    template {\n      display: none;\n    }\n    abbr[title] {\n      border-bottom: none;\n      text-decoration: underline;\n      text-decoration: underline dotted;\n    }\n    b,\n    strong {\n      font-weight: inherit;\n      font-weight: bolder;\n    }\n    dfn {\n      font-style: italic;\n    }\n    mark {\n      background-color: #ff0;\n      color: #000;\n    }\n    small {\n      font-size: 80%;\n    }\n    sub,\n    sup {\n      font-size: 75%;\n      line-height: 0;\n      position: relative;\n      vertical-align: baseline;\n    }\n    sub {\n      bottom: -0.25em;\n    }\n    sup {\n      top: -0.5em;\n    }\n    img {\n      border-style: none;\n    }\n    svg:not(:root) {\n      overflow: hidden;\n    }\n    code,\n    kbd,\n    pre,\n    samp {\n      font-family: monospace, monospace;\n      font-size: 1em;\n    }\n    figure {\n      margin: 1em 40px;\n    }\n    hr {\n      box-sizing: content-box;\n      height: 0;\n      overflow: visible;\n    }\n    button,\n    input,\n    optgroup,\n    select,\n    textarea {\n      font: inherit;\n      margin: 0;\n    }\n    optgroup {\n      font-weight: 700;\n    }\n    button,\n    input {\n      overflow: visible;\n    }\n    input:required {\n      box-shadow: none;\n    }\n    button,\n    select {\n      text-transform: none;\n    }\n    [type='reset'],\n    [type='submit'],\n    button,\n    html [type='button'] {\n      -webkit-appearance: button;\n    }\n    [type='button']::-moz-focus-inner,\n    [type='reset']::-moz-focus-inner,\n    [type='submit']::-moz-focus-inner,\n    button::-moz-focus-inner {\n      border-style: none;\n      padding: 0;\n    }\n    [type='button']:-moz-focusring,\n    [type='reset']:-moz-focusring,\n    [type='submit']:-moz-focusring,\n    button:-moz-focusring {\n      outline: 1px dotted ButtonText;\n    }\n    fieldset {\n      border: none;\n      margin: 0;\n      padding: 0;\n    }\n    legend {\n      box-sizing: border-box;\n      color: inherit;\n      display: table;\n      max-width: 100%;\n      padding: 0;\n      white-space: normal;\n    }\n    textarea {\n      overflow: auto;\n    }\n    [type='checkbox'],\n    [type='radio'] {\n      box-sizing: border-box;\n      padding: 0;\n    }\n    [type='number']::-webkit-inner-spin-button,\n    [type='number']::-webkit-outer-spin-button {\n      height: auto;\n    }\n    [type='search'] {\n      -webkit-appearance: textfield;\n      outline-offset: -2px;\n    }\n    [type='search']::-webkit-search-cancel-button,\n    [type='search']::-webkit-search-decoration {\n      -webkit-appearance: none;\n    }\n    ::-webkit-input-placeholder {\n      color: inherit;\n      opacity: 0.34;\n    }\n    ::-webkit-file-upload-button {\n      -webkit-appearance: button;\n      font: inherit;\n    }\n    img {\n      max-width: 100%;\n      margin: 0;\n      padding: 0;\n    }\n    img,\n    hgroup,\n    ul,\n    ol,\n    dl,\n    dd,\n    p,\n    figure,\n    pre,\n    table,\n    fieldset,\n    blockquote,\n    form,\n    noscript,\n    iframe,\n    hr,\n    address {\n      margin: 0;\n      padding: 0;\n    }\n    iframe {\n      border: 0;\n    }\n    ul {\n      list-style-position: outside;\n      list-style-image: none;\n    }\n    ol {\n      list-style-position: outside;\n      list-style-image: none;\n    }\n    pre {\n      font-size: 0.85rem;\n      line-height: 1.5rem;\n    }\n    table {\n      font-size: 1rem;\n      line-height: 1.5rem;\n      border-collapse: collapse;\n      width: 100%;\n    }\n    blockquote {\n      font-size: 1.22474rem;\n      line-height: 1.5rem;\n      border-left: 0.25rem solid #eceeef;\n    }\n    hr {\n      background: hsla(0, 0%, 0%, 0.2);\n      border: none;\n      height: 1px;\n    }\n    b,\n    strong,\n    dt,\n    th {\n      font-weight: bold;\n    }\n    ol li {\n      padding-left: 0;\n    }\n    ul li {\n      padding-left: 0;\n    }\n    blockquote *:last-child {\n      margin-bottom: 0;\n    }\n    li *:last-child {\n      margin-bottom: 0;\n    }\n    p *:last-child {\n      margin-bottom: 0;\n    }\n    code {\n      font-size: 0.85rem;\n      line-height: 1.5rem;\n    }\n    kbd {\n      font-size: 0.85rem;\n      line-height: 1.5rem;\n    }\n    samp {\n      font-size: 0.85rem;\n      line-height: 1.5rem;\n    }\n    abbr {\n      border-bottom: 1px dotted hsla(0, 0%, 0%, 0.5);\n      cursor: help;\n    }\n    acronym {\n      border-bottom: 1px dotted hsla(0, 0%, 0%, 0.5);\n      cursor: help;\n    }\n    abbr[title] {\n      border-bottom: 1px dotted hsla(0, 0%, 0%, 0.5);\n      cursor: help;\n      text-decoration: none;\n    }\n    thead {\n      text-align: left;\n    }\n    th {\n      text-align: left;\n      border-bottom: 1px solid hsla(0, 0%, 0%, 0.12);\n      font-feature-settings: 'tnum';\n      -moz-font-feature-settings: 'tnum';\n      -ms-font-feature-settings: 'tnum';\n      -webkit-font-feature-settings: 'tnum';\n      padding-left: 1rem;\n      padding-right: 1rem;\n      padding-top: 0.75rem;\n      padding-bottom: calc(0.75rem - 1px);\n    }\n    blockquote > :last-child {\n      margin-bottom: 0;\n    }\n    blockquote cite {\n      font-size: 1rem;\n      line-height: 1.5rem;\n      color: hsla(204, 5.275997423999999%, 0%, 0.46);\n      font-weight: 400;\n      font-style: normal;\n    }\n    &::-webkit-scrollbar {\n      width: 8px;\n      height: 8px;\n      background-color: ", ";\n    }\n    &::-webkit-scrollbar-thumb {\n      background-color: ", ";\n      border-radius: 0;\n    }\n    /* Hide filestack logo in asset picker */\n    .fsp-picker__brand {\n      display: none !important;\n    }\n    :root {\n      --reach-dialog: 1;\n      --reach-tabs: 1;\n      --reach-tooltip: 1;\n      --reach-menu-button: 1;\n    }\n  "], ["\n    html {\n      font: ", " / ", " ", ";\n      box-sizing: border-box;\n      -ms-text-size-adjust: 100%;\n      -webkit-text-size-adjust: 100%;\n      width: 100%;\n    }\n    body {\n      margin: 0;\n      color: ", ";\n      font-weight: ", ";\n      word-wrap: break-word;\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale;\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      margin: 0;\n      padding: 0;\n      color: ", ";\n    }\n    h1 {\n      line-height: ", ";\n      font-size: ", ";\n      font-weight: ", ";\n    }\n    h2 {\n      line-height: ", ";\n      font-size: ", ";\n      font-weight: ", ";\n    }\n    h3 {\n      line-height: ", ";\n      font-size: ", ";\n      font-weight: ", ";\n    }\n    h4 {\n      line-height: ", ";\n      font-size: ", ";\n      font-weight: ", ";\n    }\n    h5 {\n      line-height: ", ";\n      font-size: ", ";\n      font-weight: ", ";\n    }\n    h6 {\n      line-height: ", ";\n      font-size: ", ";\n      font-weight: ", ";\n    }\n\n    a {\n      color: inherit;\n      text-decoration: none;\n      background-color: transparent;\n      -webkit-text-decoration-skip: objects;\n    }\n    a:active,\n    a:hover {\n      outline-width: 0;\n    }\n\n    * {\n      box-sizing: inherit;\n    }\n    *:before {\n      box-sizing: inherit;\n    }\n    *:after {\n      box-sizing: inherit;\n    }\n\n    article,\n    aside,\n    details,\n    figcaption,\n    figure,\n    footer,\n    header,\n    main,\n    menu,\n    nav,\n    section,\n    summary {\n      display: block;\n    }\n    audio,\n    canvas,\n    progress,\n    video {\n      display: inline-block;\n    }\n    audio:not([controls]) {\n      display: none;\n      height: 0;\n    }\n    progress {\n      vertical-align: baseline;\n    }\n    [hidden],\n    template {\n      display: none;\n    }\n    abbr[title] {\n      border-bottom: none;\n      text-decoration: underline;\n      text-decoration: underline dotted;\n    }\n    b,\n    strong {\n      font-weight: inherit;\n      font-weight: bolder;\n    }\n    dfn {\n      font-style: italic;\n    }\n    mark {\n      background-color: #ff0;\n      color: #000;\n    }\n    small {\n      font-size: 80%;\n    }\n    sub,\n    sup {\n      font-size: 75%;\n      line-height: 0;\n      position: relative;\n      vertical-align: baseline;\n    }\n    sub {\n      bottom: -0.25em;\n    }\n    sup {\n      top: -0.5em;\n    }\n    img {\n      border-style: none;\n    }\n    svg:not(:root) {\n      overflow: hidden;\n    }\n    code,\n    kbd,\n    pre,\n    samp {\n      font-family: monospace, monospace;\n      font-size: 1em;\n    }\n    figure {\n      margin: 1em 40px;\n    }\n    hr {\n      box-sizing: content-box;\n      height: 0;\n      overflow: visible;\n    }\n    button,\n    input,\n    optgroup,\n    select,\n    textarea {\n      font: inherit;\n      margin: 0;\n    }\n    optgroup {\n      font-weight: 700;\n    }\n    button,\n    input {\n      overflow: visible;\n    }\n    input:required {\n      box-shadow: none;\n    }\n    button,\n    select {\n      text-transform: none;\n    }\n    [type='reset'],\n    [type='submit'],\n    button,\n    html [type='button'] {\n      -webkit-appearance: button;\n    }\n    [type='button']::-moz-focus-inner,\n    [type='reset']::-moz-focus-inner,\n    [type='submit']::-moz-focus-inner,\n    button::-moz-focus-inner {\n      border-style: none;\n      padding: 0;\n    }\n    [type='button']:-moz-focusring,\n    [type='reset']:-moz-focusring,\n    [type='submit']:-moz-focusring,\n    button:-moz-focusring {\n      outline: 1px dotted ButtonText;\n    }\n    fieldset {\n      border: none;\n      margin: 0;\n      padding: 0;\n    }\n    legend {\n      box-sizing: border-box;\n      color: inherit;\n      display: table;\n      max-width: 100%;\n      padding: 0;\n      white-space: normal;\n    }\n    textarea {\n      overflow: auto;\n    }\n    [type='checkbox'],\n    [type='radio'] {\n      box-sizing: border-box;\n      padding: 0;\n    }\n    [type='number']::-webkit-inner-spin-button,\n    [type='number']::-webkit-outer-spin-button {\n      height: auto;\n    }\n    [type='search'] {\n      -webkit-appearance: textfield;\n      outline-offset: -2px;\n    }\n    [type='search']::-webkit-search-cancel-button,\n    [type='search']::-webkit-search-decoration {\n      -webkit-appearance: none;\n    }\n    ::-webkit-input-placeholder {\n      color: inherit;\n      opacity: 0.34;\n    }\n    ::-webkit-file-upload-button {\n      -webkit-appearance: button;\n      font: inherit;\n    }\n    img {\n      max-width: 100%;\n      margin: 0;\n      padding: 0;\n    }\n    img,\n    hgroup,\n    ul,\n    ol,\n    dl,\n    dd,\n    p,\n    figure,\n    pre,\n    table,\n    fieldset,\n    blockquote,\n    form,\n    noscript,\n    iframe,\n    hr,\n    address {\n      margin: 0;\n      padding: 0;\n    }\n    iframe {\n      border: 0;\n    }\n    ul {\n      list-style-position: outside;\n      list-style-image: none;\n    }\n    ol {\n      list-style-position: outside;\n      list-style-image: none;\n    }\n    pre {\n      font-size: 0.85rem;\n      line-height: 1.5rem;\n    }\n    table {\n      font-size: 1rem;\n      line-height: 1.5rem;\n      border-collapse: collapse;\n      width: 100%;\n    }\n    blockquote {\n      font-size: 1.22474rem;\n      line-height: 1.5rem;\n      border-left: 0.25rem solid #eceeef;\n    }\n    hr {\n      background: hsla(0, 0%, 0%, 0.2);\n      border: none;\n      height: 1px;\n    }\n    b,\n    strong,\n    dt,\n    th {\n      font-weight: bold;\n    }\n    ol li {\n      padding-left: 0;\n    }\n    ul li {\n      padding-left: 0;\n    }\n    blockquote *:last-child {\n      margin-bottom: 0;\n    }\n    li *:last-child {\n      margin-bottom: 0;\n    }\n    p *:last-child {\n      margin-bottom: 0;\n    }\n    code {\n      font-size: 0.85rem;\n      line-height: 1.5rem;\n    }\n    kbd {\n      font-size: 0.85rem;\n      line-height: 1.5rem;\n    }\n    samp {\n      font-size: 0.85rem;\n      line-height: 1.5rem;\n    }\n    abbr {\n      border-bottom: 1px dotted hsla(0, 0%, 0%, 0.5);\n      cursor: help;\n    }\n    acronym {\n      border-bottom: 1px dotted hsla(0, 0%, 0%, 0.5);\n      cursor: help;\n    }\n    abbr[title] {\n      border-bottom: 1px dotted hsla(0, 0%, 0%, 0.5);\n      cursor: help;\n      text-decoration: none;\n    }\n    thead {\n      text-align: left;\n    }\n    th {\n      text-align: left;\n      border-bottom: 1px solid hsla(0, 0%, 0%, 0.12);\n      font-feature-settings: 'tnum';\n      -moz-font-feature-settings: 'tnum';\n      -ms-font-feature-settings: 'tnum';\n      -webkit-font-feature-settings: 'tnum';\n      padding-left: 1rem;\n      padding-right: 1rem;\n      padding-top: 0.75rem;\n      padding-bottom: calc(0.75rem - 1px);\n    }\n    blockquote > :last-child {\n      margin-bottom: 0;\n    }\n    blockquote cite {\n      font-size: 1rem;\n      line-height: 1.5rem;\n      color: hsla(204, 5.275997423999999%, 0%, 0.46);\n      font-weight: 400;\n      font-style: normal;\n    }\n    &::-webkit-scrollbar {\n      width: 8px;\n      height: 8px;\n      background-color: ", ";\n    }\n    &::-webkit-scrollbar-thumb {\n      background-color: ", ";\n      border-radius: 0;\n    }\n    /* Hide filestack logo in asset picker */\n    .fsp-picker__brand {\n      display: none !important;\n    }\n    :root {\n      --reach-dialog: 1;\n      --reach-tabs: 1;\n      --reach-tooltip: 1;\n      --reach-menu-button: 1;\n    }\n  "])), fontSizes.interface, lineHeights.regular, fonts.body, colors.text, fontWeights.body, colors.heading, lineHeights.h1, fontSizes.h1, fontWeights.h1, lineHeights.h2, fontSizes.h2, fontWeights.h2, lineHeights.h3, fontSizes.h3, fontWeights.h3, lineHeights.h4, fontSizes.h4, fontWeights.h4, lineHeights.h5, fontSizes.h5, fontWeights.h5, lineHeights.h6, fontSizes.h6, fontWeights.h6, colors.neutral[25], colors.neutral[100]);
});
var templateObject_1;

var BaukastenThemeProvider = function (props) {
    var _a = props.theme, theme = _a === void 0 ? baukastenTheme : _a, _b = props.children, children = _b === void 0 ? null : _b, _c = props.global, global = _c === void 0 ? false : _c;
    var globalStyle = makeGlobalStyles(baukastenTheme);
    return (React.createElement(ThemeProvider$1, { theme: theme },
        global && React.createElement(Global, { styles: globalStyle }),
        children));
};
var ThemeProvider = function (props) {
    var _a = props.theme, theme = _a === void 0 ? baukastenTheme : _a, themeOverride = props.themeOverride, _b = props.global, global = _b === void 0 ? false : _b, _c = props.children, children = _c === void 0 ? null : _c;
    // TODO reflect theme overrides in muiTheme
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_emotion_react__WEBPACK_IMPORTED_MODULE_3__.a, { theme: theme },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_emotion_react__WEBPACK_IMPORTED_MODULE_3__.a, { theme: themeOverride || {} },
            global && react__WEBPACK_IMPORTED_MODULE_0__.createElement(_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .Global */ .xB, { styles: makeGlobalStyles(baukastenTheme) }),
            children)));
};


//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(9864);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(66);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 66:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@fontsource/inter/variable.css
var variable = __webpack_require__(3872);
// EXTERNAL MODULE: ./node_modules/@hygraph/theme/dist/index.esm.js
var index_esm = __webpack_require__(3067);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/pages/_app.tsx





function MyApp(param) {
    var Component = param.Component, pageProps = param.pageProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ThemeProvider */.f6, {
        global: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, _objectSpread({}, pageProps))
        })
    });
}
/* harmony default export */ var _app = (MyApp);


/***/ }),

/***/ 3872:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 9921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 9864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(9921);
} else {}


/***/ }),

/***/ 7462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,179], function() { return __webpack_exec__(6840), __webpack_exec__(387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);